// export const basciUrl = 'https://kpi.taskwinone.com'
export const basciUrl = ''